import "./HeaderHero.css";
import { useEffect, useState } from "react";

export default function HeaderHero({
    videoSrc = "img/video1.mp4",
    posterSrc = "/img/hero-fallback.jpg",
    logoSrc = "/img/Logos/unihubLogo1.png",
} = {}) {
    const [videoError, setVideoError] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && setMenuOpen(false);
        const onResize = () => { if (window.innerWidth >= 992) setMenuOpen(false); };
        window.addEventListener("keydown", onKey);
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("keydown", onKey);
            window.removeEventListener("resize", onResize);
        };
    }, []);

    useEffect(() => {
        document.documentElement.style.overflow = menuOpen ? "hidden" : "";
        return () => { document.documentElement.style.overflow = ""; };
    }, [menuOpen]);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="header-hero">

            {/* BACKGROUND */}
            {!videoError ? (
                <video
                    className="hero-video"
                    src={videoSrc}
                    poster={posterSrc}
                    autoPlay
                    muted
                    playsInline
                    loop
                    preload="metadata"
                    onError={() => setVideoError(true)}
                />
            ) : (
                <img src={posterSrc} alt="" className="hero-video" />
            )}
            <div className="hero-overlay" />

            {/* NAV */}
            <nav className="hero-nav" aria-label="Primary">
                <a href="/" className="nav-brand" aria-label="Inicio">
                    <img src={logoSrc} alt="University Hub" className="nav-logo" />
                </a>
                <ul className="nav-links">
                    <li><a href="#about">Quiénes somos</a></li>
                    <li><a href="#past-events">Novedades</a></li>
                    <li><a href="#footer">Contáctanos</a></li>
                </ul>
                <button
                    type="button"
                    className="burger"
                    aria-label="Abrir menú"
                    aria-expanded={menuOpen}
                    aria-controls="mobile-menu"
                    onClick={() => setMenuOpen((v) => !v)}
                >
                    <span className="burger-icon" />
                </button>
            </nav>

            {/* MOBILE DRAWER */}
            <div
                id="mobile-menu"
                className={`drawer ${menuOpen ? "is-open" : ""}`}
                role="dialog"
                aria-modal="true"
                aria-label="Menú principal"
            >
                <div className="drawer-header">
                    <img src={logoSrc} alt="" className="nav-logo" />
                    <button
                        type="button"
                        className="drawer-close"
                        aria-label="Cerrar menú"
                        onClick={closeMenu}
                    >
                        <span className="burger-icon close" />
                    </button>
                </div>
                <ul className="drawer-links" onClick={closeMenu}>
                    <li><a href="#about">QUIÉNES SOMOS</a></li>
                    <li><a href="#past-events">NOVEDADES</a></li>
                    <li><a href="#footer">CONTACTANOS</a></li>
                </ul>
            </div>
            <button
                type="button"
                className={`drawer-backdrop ${menuOpen ? "show" : ""}`}
                aria-label="Cerrar menú"
                onClick={closeMenu}
            />

            {/* HERO CONTENT */}
            <div className="hero-content">
                <h1 className="hero-title">INNOVACION, TECNOLOGIA Y GAMING</h1>
                <p className="hero-subtitle">
                    Creamos experiencias inmersivas en el ecosistema universitario.<br />
                    Somos partners de 40+ Universidades en Latam.
                </p>
                <a
                    href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2ASMVHo_RDrOdDZxfPlTEWWUhuKFUsxYs2yx0y-GjIpFdS4NPh8UgdZjsSXgMCv4vWSYC04AfW?gv=true"
                    className="hero-cta"
                    target="_blank"
                    rel="noopener noreferrer"
                >Contactanos</a>
            </div>

            {/* SOCIAL LINKS */}
            <div className="hero-social">
                <a
                    href="https://www.linkedin.com/company/university-hub-latam/?originalSubdomain=ar"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                    className="hero-social-link"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M20.45 20.45h-3.554v-5.569c0-1.328-.024-3.037-1.85-3.037-1.851 0-2.134 1.445-2.134 2.939v5.667H9.358V9h3.414v1.561h.048c.476-.9 1.637-1.85 3.368-1.85 3.6 0 4.267 2.369 4.267 5.455v6.284zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM6.87 20.45H3.805V9H6.87v11.45zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                </a>
                <a
                    href="https://www.instagram.com/uhublatam/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="hero-social-link"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
                    </svg>
                </a>
            </div>

        </header>
    );
}
